export enum partTypeEnum {
    body = 'body',
}